import type { MatterMemberRead } from '@/matter/components/manage-members/schemas'
import { getInitialsFromString } from '@/util/string-utils'

export { getInitialsFromString }

export const kUnavailableMemberDisplayName = 'Unavailable user'
const kUnavailableMemberInitials = 'U'

export function getMemberInitials(member: MatterMemberRead): string {
  const displaySource = member.display_name ?? member.email
  if (!displaySource) return kUnavailableMemberInitials
  return getInitialsFromString(displaySource)
}

export function getMemberDisplayName(member: MatterMemberRead): string {
  return member.display_name ?? member.email ?? kUnavailableMemberDisplayName
}
